import { BrowserRouter, Switch } from "react-router-dom";

import {
  adminServices,
  getAllServices,
  isAllowedService,
} from "../utils/services";
import { Route } from "react-router-dom";

import SignUp from "../components/signUp/signup";
import Login from "../pages/login";

import { PrivateRoute } from "../routes/PrivateRoutes";
import PublicRoute from "../routes/PublicRoutes";
import NotFound from "../components/common/NotFound";
import ShopDetails from "../pages/shops/details";
import ShopOrders from "../pages/shops/orders";
import ShopSalesMan from "../pages/shops/sales-man";
import ShopCategory from "../pages/shops/categories";
import ShopCategoryDetails from "../pages/shops/categories/categoryDetails";
import ShopProductPage from "../pages/shops/products";
import ShopProductBulkUploadPage from "../pages/shops/products/bulkupload";
import ShopProductBulkUpdatePage from "../pages/shops/products/bulkupdate";
import UserDetailsPage from "../pages/users/details";
import CustomerOrderPage from "../pages/users/orders";

import DriversDetailsPage from "../pages/drivers/details";
import DriverTransactionPage from "../pages/drivers/transactions";
import DriverLocationHistoryPage from "../pages/drivers/location-history";
import DriverOrdersPage from "../pages/drivers/orders";

import ProductDetailsPage from "../pages/products/details";
import ShopProductDetailsPage from "../pages/shops/products/details";
import ShopProductAddPage from "../pages/shops/products/add";
import ShopProductEditPage from "../pages/shops/products/edit";
import ShopOrderDetailsPage from "../pages/shops/orders/details";
import ShopBrandsPage from "../pages/shops/brand/index";
import ShopCampaignsPage from "../pages/shops/campaigns/index";
import UserTransactionPage from "../pages/finance/transactions";

import ShopAddPage from "../pages/shops/add";
import ShopEditPage from "../pages/shops/edit";

import MerchantTransactionPage from "../pages/shops/transactions";
import DriversCashCollectPage from "../pages/drivers/cash-collect";

import HubDetailsPage from "../pages/hubs/details";
import HubShopPage from "../pages/hubs/shops";
import HubCategoryPage from "../pages/hubs/categories";
import HubAreaPage from "../pages/hubs/areas";
import HubCategoryDetailsPage from "../pages/hubs/categories/categoryDetails";
import HubShopDetailsPage from "../pages/hubs/shops/details";
import HubCampaignsPage from "../pages/hubs/campaigns/index";
import HubBrandsPage from "../pages/hubs/brands/index";

import MerchantDetailsPage from "../pages/merchants/details";
import MerchantShopPage from "../pages/merchants/shops";
import MerchantShopDetailsPage from "../pages/merchants/shops/details";

import HubOrderPage from "../pages/hubs/orders";
import HubOrderDetailsPage from "../pages/hubs/orders/details";
import ShopSupplierPage from "../pages/shops/suppliers";
import ShopOutOfStockPage from "../pages/shops/products/out-of-stock";
import ShopRecycleBinPage from "../pages/shops/products/recycle-bin";

import CorporateDetailsPage from "../pages/corporates/details";
import CorporateEmployeepage from "../pages/corporates/employees";
import HubProductPage from "../pages/hubs/products";

import GlobalCategoryDetailsPage from "../pages/global-category/details";
import SubCategoryPage from "../pages/global-category/sub-categories";
import FeedbackDetailsPage from "../pages/feedback/details";
import CorporateEmployeeGroupPage from "../pages/corporates/employee-group";
import ProductOrderPage from "../pages/finance/product-order";

import CampaignDetailsPage from "../pages/campaigns/details";
import CampaignProductPage from "../pages/campaigns/products";

import Dashboard from "../components/Dashboard";
import DriverUnsettleOrderPage from "../pages/drivers/unsettle-orders";
import MerchantCashPayPage from "../pages/shops/cash-pay";
import CorporateTopupHistoryPage from "../pages/corporates/topup";
import TopUpDetailsPage from "../pages/corporates/topup/details";

import Neighborhood from "../components/Neighborhood";
import NeighborhoodAddPage from "../pages/Neighborhood/add";
import ViewAllNeighborhoodPage from "../pages/Neighborhood/viewAllNeighborhood";

const Routes = (): any => {
  return (
    <BrowserRouter>
      <Switch>
        {adminServices?.flatMap((service, index) => {
          if (service?.sub?.length) {
            return [
              ...(service?.sub?.map((sub, i) => {
                const ServiceElemnt = sub?.component;
                return (
                  isAllowedService(`${service.name} ${sub.name}`) && (
                    <PrivateRoute
                      key={i}
                      exact={true}
                      path={`${process.env.PUBLIC_URL}${service?.path}${sub?.path}`}
                      component={sub?.component}
                    />
                  )
                );
              }) || []),
            ];
          } else {
            const ServiceElemnt = service?.component;
            return (
              isAllowedService(service?.name) && (
                <PrivateRoute
                  exact={true}
                  path={`${process.env.PUBLIC_URL}${service?.path}`}
                  component={service?.component}
                />
              )
            );
          }
        })}

        <PrivateRoute
          exact={true}
          path={`${process.env.PUBLIC_URL}/`}
          component={Dashboard}
        />

        <PublicRoute
          exact={true}
          restricted={true}
          path={`${process.env.PUBLIC_URL}/login`}
          component={Login}
        />
        <PublicRoute
          exact={true}
          restricted={true}
          path={`${process.env.PUBLIC_URL}/signup`}
          component={SignUp}
        />
        <PrivateRoute
          exact={true}
          path={`${process.env.PUBLIC_URL}/products/:slug/details`}
          component={ProductDetailsPage}
        />
        <PrivateRoute
          exact={true}
          path={`${process.env.PUBLIC_URL}/neighborhood/details`}
          component={ViewAllNeighborhoodPage}
        />
        {/* <PrivateRoute
          exact={true}
          path={`${process.env.PUBLIC_URL}/products/:slug/edit=multiple-shop`}
          component={ProductEditMultiple}
        /> */}
        {/* <PrivateRoute
          exact={true}
          path={`${process.env.PUBLIC_URL}/products/add`}
          component={ProductAddPage}
        /> */}
        <PrivateRoute
          exact={true}
          path={`${process.env.PUBLIC_URL}/global-categories/:categoryId/details`}
          component={GlobalCategoryDetailsPage}
        />
        <PrivateRoute
          exact={true}
          path={`${process.env.PUBLIC_URL}/global-categories/:categoryId/sub-categories`}
          component={SubCategoryPage}
        />
        {/* 

        {/* Hub Managment */}
        <PrivateRoute
          exact={true}
          path={`${process.env.PUBLIC_URL}/hubs/:hubId/details`}
          component={HubDetailsPage}
        />
        <PrivateRoute
          exact={true}
          path={`${process.env.PUBLIC_URL}/hubs/:hubId/shops`}
          component={HubShopPage}
        />
        <PrivateRoute
          exact={true}
          path={`${process.env.PUBLIC_URL}/hubs/:hubId/shop/:shopId`}
          component={HubShopDetailsPage}
        />
        <PrivateRoute
          exact={true}
          path={`${process.env.PUBLIC_URL}/hubs/:hubId/categories`}
          component={HubCategoryPage}
        />
        <PrivateRoute
          exact={true}
          path={`${process.env.PUBLIC_URL}/hubs/:hubId/products`}
          component={HubProductPage}
        />
        <PrivateRoute
          exact={true}
          path={`${process.env.PUBLIC_URL}/hubs/:hubId/categories/:categoryId`}
          component={HubCategoryDetailsPage}
        />
        <PrivateRoute
          exact={true}
          path={`${process.env.PUBLIC_URL}/hubs/:hubId/areas`}
          component={HubAreaPage}
        />
        <PrivateRoute
          exact={true}
          path={`${process.env.PUBLIC_URL}/hubs/:hubId/orders`}
          component={HubOrderPage}
        />
        <PrivateRoute
          exact={true}
          path={`${process.env.PUBLIC_URL}/hubs/:hubId/orders/:orderId/details`}
          component={HubOrderDetailsPage}
        />
        <PrivateRoute
          exact={true}
          path={`${process.env.PUBLIC_URL}/hubs/:hubId/campaigns`}
          component={HubCampaignsPage}
        />
        <PrivateRoute
          exact={true}
          path={`${process.env.PUBLIC_URL}/hubs/:hubId/brands`}
          component={HubBrandsPage}
        />
        {/*  /Hub Managment */}
        {/* Hub Managment */}
        <PrivateRoute
          exact={true}
          path={`${process.env.PUBLIC_URL}/merchants/:merchantId/details`}
          component={MerchantDetailsPage}
        />
        <PrivateRoute
          exact={true}
          path={`${process.env.PUBLIC_URL}/merchants/:merchantId/shops`}
          component={MerchantShopPage}
        />
        <PrivateRoute
          exact={true}
          path={`${process.env.PUBLIC_URL}/merchants/:merchantId/shop/:shopId`}
          component={HubShopDetailsPage}
        />
        <PrivateRoute
          exact={true}
          path={`${process.env.PUBLIC_URL}/merchants/:merchantId/shop/:shopId`}
          component={MerchantShopDetailsPage}
        />
        {/* Hub Managment */}
        {/* Shop Managment */}
        <PrivateRoute
          exact={true}
          path={`${process.env.PUBLIC_URL}/shops/add`}
          component={ShopAddPage}
        />
        <PrivateRoute
          exact={true}
          path={`${process.env.PUBLIC_URL}/shops/:shopId/edit`}
          component={ShopEditPage}
        />
        <PrivateRoute
          exact={true}
          path={`${process.env.PUBLIC_URL}/shops/:shopId/details`}
          component={ShopDetails}
        />
        <PrivateRoute
          exact={true}
          path={`${process.env.PUBLIC_URL}/shops/:shopId/orders`}
          component={ShopOrders}
        />
        <PrivateRoute
          exact={true}
          path={`${process.env.PUBLIC_URL}/shops/:shopId/orders/:orderId/details`}
          component={ShopOrderDetailsPage}
        />
        <PrivateRoute
          exact={true}
          path={`${process.env.PUBLIC_URL}/shops/:shopId/categories`}
          component={ShopCategory}
        />
        <PrivateRoute
          exact={true}
          path={`${process.env.PUBLIC_URL}/shops/:shopId/categories/:categoryId`}
          component={ShopCategoryDetails}
        />
        <PrivateRoute
          exact={true}
          path={`${process.env.PUBLIC_URL}/shops/:shopId/campaigns`}
          component={ShopCampaignsPage}
        />
        <PrivateRoute
          exact={true}
          path={`${process.env.PUBLIC_URL}/shops/:shopId/brands`}
          component={ShopBrandsPage}
        />
        <PrivateRoute
          exact={true}
          path={`${process.env.PUBLIC_URL}/shops/:shopId/products`}
          component={ShopProductPage}
        />
        <PrivateRoute
          exact={true}
          path={`${process.env.PUBLIC_URL}/shops/:shopId/bulkupload`}
          component={ShopProductBulkUploadPage}
        />
        <PrivateRoute
          exact={true}
          path={`${process.env.PUBLIC_URL}/shops/:shopId/bulkupdate`}
          component={ShopProductBulkUpdatePage}
        />
        <PrivateRoute
          exact={true}
          path={`${process.env.PUBLIC_URL}/shops/:shopId/out-of-stock`}
          component={ShopOutOfStockPage}
        />
        <PrivateRoute
          exact={true}
          path={`${process.env.PUBLIC_URL}/shops/:shopId/recycle-bin`}
          component={ShopRecycleBinPage}
        />
        <PrivateRoute
          exact={true}
          path={`${process.env.PUBLIC_URL}/shops/:shopId/products/add`}
          component={ShopProductAddPage}
        />
        <PrivateRoute
          exact={true}
          path={`${process.env.PUBLIC_URL}/shops/:shopId/products/:slug/edit`}
          component={ShopProductEditPage}
        />
        <PrivateRoute
          exact={true}
          path={`${process.env.PUBLIC_URL}/shops/:shopId/products/:slug/details`}
          component={ShopProductDetailsPage}
        />
        <PrivateRoute
          exact={true}
          path={`${process.env.PUBLIC_URL}/shops/:shopId/sales-man`}
          component={ShopSalesMan}
        />
        <PrivateRoute
          exact={true}
          path={`${process.env.PUBLIC_URL}/shops/:shopId/suppliers`}
          component={ShopSupplierPage}
        />
        <PrivateRoute
          exact={true}
          path={`${process.env.PUBLIC_URL}/shops/:shopId/cash-pay`}
          component={MerchantCashPayPage}
        />
        <PrivateRoute
          exact={true}
          path={`${process.env.PUBLIC_URL}/shops/:shopId/transactions`}
          component={MerchantTransactionPage}
        />
        {/* /Shop Managment */}
        <PrivateRoute
          exact={true}
          path={`${process.env.PUBLIC_URL}/finance/transactions`}
          component={UserTransactionPage}
        />
        <PrivateRoute
          exact={true}
          path={`${process.env.PUBLIC_URL}/finance/product-order`}
          component={ProductOrderPage}
        />
        <PrivateRoute
          exact={true}
          path={`${process.env.PUBLIC_URL}/drivers/:id/details`}
          component={DriversDetailsPage}
        />
        <PrivateRoute
          exact={true}
          path={`${process.env.PUBLIC_URL}/drivers/:id/transactions`}
          component={DriverTransactionPage}
        />
        <PrivateRoute
          exact={true}
          path={`${process.env.PUBLIC_URL}/drivers/:id/locationhistory`}
          component={DriverLocationHistoryPage}
        />
        <PrivateRoute
          exact={true}
          path={`${process.env.PUBLIC_URL}/drivers/:id/orders`}
          component={DriverOrdersPage}
        />
        <PrivateRoute
          exact={true}
          path={`${process.env.PUBLIC_URL}/drivers/:id/unsettle-orders`}
          component={DriverUnsettleOrderPage}
        />
        <PrivateRoute
          exact={true}
          path={`${process.env.PUBLIC_URL}/drivers/:id/cash-collect`}
          component={DriversCashCollectPage}
        />
        <PrivateRoute
          exact={true}
          path={`${process.env.PUBLIC_URL}/corporates/:corporateId/details`}
          component={CorporateDetailsPage}
        />
        <PrivateRoute
          exact={true}
          path={`${process.env.PUBLIC_URL}/corporates/:corporateId/employee-group`}
          component={CorporateEmployeeGroupPage}
        />
        <PrivateRoute
          exact={true}
          path={`${process.env.PUBLIC_URL}/corporates/:corporateId/employees`}
          component={CorporateEmployeepage}
        />
        <PrivateRoute
          exact={true}
          path={`${process.env.PUBLIC_URL}/corporates/:corporateId/topup`}
          component={CorporateTopupHistoryPage}
        />
        <PrivateRoute
          exact={true}
          path={`${process.env.PUBLIC_URL}/corporates/:corporateId/topup/:topupId`}
          component={TopUpDetailsPage}
        />
        <PrivateRoute
          exact={true}
          path={`${process.env.PUBLIC_URL}/feedback/:feedbackId/details`}
          component={FeedbackDetailsPage}
        />

        {/* <PrivateRoute
          exact={true}
          path={`${process.env.PUBLIC_URL}/administration/admins`}
          component={AdminsPage}
        />

        <PrivateRoute
          exact={true}
          path={`${process.env.PUBLIC_URL}/administration/groups`}
          component={AdminGroupPage}
        />

        <PrivateRoute
          exact={true}
          path={`${process.env.PUBLIC_URL}/administration/services`}
          component={AdminServicePage}
        />

        <PrivateRoute
          exact={true}
          path={`${process.env.PUBLIC_URL}/administration/service-groups`}
          component={ServiceGroupPage}
        />

        <PrivateRoute
          exact={true}
          path={`${process.env.PUBLIC_URL}/administration/user-groups`}
          component={UserGroupPage}
        /> */}
        <Route exact path="*" component={NotFound} />
      </Switch>
    </BrowserRouter>
  );
};
export default Routes;
